import { ITracking } from "./itracking";
import { Config } from "app/core/vo/config";
import { TrackingVO } from "app/core/tracking/trackingvo";
import { NotifierService } from "app/services/notifierService/notifier.service";
import { HttpService } from "../../services/http.service";
import { Logger } from "app/helpers/Logger";
import { AppServices } from "app/app.services";
import { UtilityScripts } from "app/helpers/utility-scripts";

export class BaseTracking extends NotifierService implements ITracking {
	protected completedVal: string;
	protected quietComplete: boolean;
	protected scoreMode: number;
	protected timeSaveMode: number;
	protected timeSingleSend: boolean;
	protected escapeCount: number;
	protected bkMkFreq: number;
	protected strOrigStatus: string;
	protected logLevel: number;
	protected environment: string;
	protected bInteractionEnabled: boolean;
	protected terminateSingleSend: boolean;
	protected readonly interactionPrefix: string = "urn:nvglobal:";

	public trackingVO: TrackingVO;
	protected cbt_data;

	public init(
		configVO: any,
		httpService: HttpService = null,
		appService: AppServices = null
	) {
		this.initProperties(configVO);
		this.initTrackingVO();
	}
	protected initProperties(data) {
		this.cbt_data = data;
		this.completedVal = data.completedVal;
		this.quietComplete = data.quietComplete;
		this.scoreMode = data.scoreMode;
		this.timeSaveMode = data.timeSaveMode;
		this.timeSingleSend = data.timeSingleSend;
		this.escapeCount = data.escapeCount;
		this.bkMkFreq = data.bkMkFreq;
		this.bInteractionEnabled = false;
		this.logLevel = data.logLevel;
		this.environment = data.environment;
		this.terminateSingleSend = data.terminateSingleSend;
		Logger.init(this.environment, this.logLevel);
	}

	protected initTrackingVO() {
		this.trackingVO = new TrackingVO();
	}

	protected notifyInitialize() {
		this._notifier.next(this.trackingVO);
	}

	public doInitialize(): void {
		console.log("doInitialize");
	}

	public doGetValue(prop: string): string {
		console.log("doGetValue for " + prop);
		return null;
	}

	public doSetValue(prop: string, value: string): void {
		console.log("doSetValue for " + prop + " as " + value);
	}

	public doCommit(): boolean {
		console.log("doCommit");
		return false;
	}

	public async doFinish() {
		console.log("doFinish");
		return false;
	}
	protected setInteractionCount(): void {}

	public updateScreenInteraction(): void {}
	public resolve_lesson_location(value) {
		if (typeof value != "string") return "";
		value = value.trim();
		if (value.match(/^(undefined|null|0|true|false)$/i) != null) return "";
		return value;
	}
	public resolve_suspend_data(value) {
		return this.resolve_lesson_location(value);
	}
	/* This method checks whether the bookmark value received in suspend data is valid or an undefined value */
	protected isBookmarkCorrupted(suspenddata):Boolean{
		if (suspenddata) {
			let suspendData = suspenddata;
			suspendData = UtilityScripts.dataEscapeUnescape(
				suspendData,
				"unescape",
				this.escapeCount
			);
			let arrSuspendData = suspendData.split("&");
			let arrBookmark = arrSuspendData[0].split(">");
			if(arrBookmark[1] == "undefined"){
				return true;
			}
			return false;
		}
	}
}
